import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

type LayoutComponent = any; // you can tighten this if you have a base layout type

export const useRouteMetaOverrideStore = defineStore('routeMetaOverride', () => {
  // overrides (null = no override)
  const layoutComponent = ref<LayoutComponent | null>(null);
  const layoutPageTitle = ref<string | null>(null);
  const pageTitle = ref<string | null>(null);
  const notificationBanner = ref<{ title: string; text: string } | null>();

  // helpers
  function setOverrides(overrides: {
    layoutComponent?: LayoutComponent | null;
    layoutPageTitle?: string | null;
    pageTitle?: string | null;
    notificationBanner?: { title: string; text: string } | null;
  }) {
    if ('layoutComponent' in overrides) layoutComponent.value = overrides.layoutComponent ?? null;
    if ('layoutPageTitle' in overrides) layoutPageTitle.value = overrides.layoutPageTitle ?? null;
    if ('pageTitle' in overrides) pageTitle.value = overrides.pageTitle ?? null;
    if ('notificationBanner' in overrides)
      notificationBanner.value = overrides.notificationBanner ?? null;
  }

  function clearOverrides() {
    layoutComponent.value = null;
    layoutPageTitle.value = null;
    pageTitle.value = null;
    notificationBanner.value = null;
  }

  function clearNotificationBanner() {
    notificationBanner.value = null;
  }

  const hasOverrides = computed(
    () =>
      layoutComponent.value !== null || layoutPageTitle.value !== null || pageTitle.value !== null,
  );

  return {
    // state
    layoutComponent,
    layoutPageTitle,
    pageTitle,
    notificationBanner,

    // derived
    hasOverrides,

    // actions
    setOverrides,
    clearOverrides,
    clearNotificationBanner,
  };
});
